import axios from './api'
import APP_ENVIRONMENT from '../environment/environment'
import localStorageService from './localStorage'

const URL_SESSION = APP_ENVIRONMENT.PATH.SESSION

async function login(user) {
  return axios.post(`${URL_SESSION}/login`, user, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
}
async function me() {
  return axios.get(`${URL_SESSION}/me`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorageService.get('token')}`,
    },
  })
}
async function registerGuest(data) {
  return axios.post(`${URL_SESSION}/registerGuest`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorageService.get('token')}`,
    },
  })
}
const sessionApi = {
  login,
  me,
  registerGuest,
}

export default sessionApi
